

const searchStyle = (theme) => ({
  width: 200,
  borderBottom: theme === "dark" ? "solid #01E3F0 1px" : "solid #CADCF8 1px",
});
const getOptionStyle = (theme) => {
  return {
    marginRight: "0",
    fontFamily: "Saira",
    fontStyle: "normal",
    fontWeight: "300",
    lineHeight: "25px",
    fontSize: "14px",
    border: theme === 'dark' ? '#1D5F70' : '#2b6fd6',
    color: theme === 'dark' ? '#01f1ff' : '#262E40',
    backgroundColor: theme === 'dark' ? '#253546' : '#FFFFFF',
  };
};
const optionSelect = (theme) => {
  return {
    color: "#01f1ff",
    border: "1px solid #1D5F70",
    marginRight: "5px",
    fontFamily: "Saira",
    fontStyle: "normal",
    // fontSize: "16px",
    fontWeight: "700",
    lineHeight: "25px",
  };
};
const twinButton = (theme) => {
  return {
    color: theme === "dark" ? "#01f1ff" : "#2B6FD6",
    border: theme === "dark" ? "1px solid #1D5F70" : "1px solid #CADCF8",
    marginRight: "5px",
    fontFamily: "Saira",
    fontStyle: "normal",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "25px",
    height: "35px",
  };
};
const modelUploadNote =(theme)=> ({
  fontSize: 12,
  color: theme === "dark" ? "#ffffff" : "#262E40"
});
const errorredNote = {
  fontSize: 12,
  color: "#FF4F59"
};
const activeStyle = (theme) => ({
  color: theme === "dark" ? "#FFFFFF" : "#262E40",
  fontFamily: "Saira",
  fontSize: "18px",
  fontStyle: "normal",
  marginTop: "27px",
  height: "28px",
  fontWeight: "700",
});
const deActiveStyle = (theme) => ({
  color: theme === "dark" ? "#b2bcca" : "#515866",
  fontFamily: "Saira",
  fontSize: "18px",
  fontstyle: "normal",
  marginTop: "27px",
  height: "28px",
  fontWeight: "500",
});
const titleStyle = (theme) => ({
  color: theme === "dark" ? "#BEC0C6" : "#515866",
  marginBottom: "0px",
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "24px",
  textAlign: "center",
  marginTop: "10px",
  marginLeft: "25px",
});
const deleteStyle = {
  marginRight: "5px",
  fontFamily: "Saira",
  fontStyle: "normal",
  fontSize: "12px",
  fontWeight: "700",
  lineHeight: "25px",
};
const disabledelete = {
  color: "#92969F",
  border: "1px solid #92969F",
  marginRight: "5px",
  fontFamily: "Saira",
  fontStyle: "normal",
  fontSize: "12px",
  fontWeight: "700",
  lineHeight: "25px",
};
const enabledelete = {
  color: "#01f1ff",
  border: "1px solid #1D5F70",
  marginRight: "5px",
  fontFamily: "Saira",
  fontStyle: "normal",
  fontSize: "12px",
  fontWeight: "700",
  lineHeight: "25px",
};

const modelDelConfirmNo = {
  border: "1px solid #1D5F70",
  backgroundColor: "#262E40",
  color: "#01F1FF",
  fontWeight: "700",
  padding: "4px 64px",
};
const modelDelConfirm = {
  backgroundColor: "#1d5f70",
  color: "#01f1ff",
  fontWeight: "700",
  padding: "4px 64px",
};
const delYesAlign = {
  float: "right",
};

const logoStyle = {
  marginLeft: '-15px',
  marginTop: '8px',
  opacity: 0.3
}
const TooltipOverlayInnerStyle = (theme) => ({
  backgroundColor: theme === "dark" ? "#ffffff" : "#262E40",
  color: theme === "dark" ? "#262E40" : "#ffffff",
  fontWeight: 500,
  fontSize: "12px",
  padding: "8px 12px"
})


export {
  searchStyle,
  twinButton,
  modelUploadNote,
  errorredNote,
  activeStyle,
  deActiveStyle,
  titleStyle,
  optionSelect,
  disabledelete,
  enabledelete,
  deleteStyle,
  modelDelConfirmNo,
  modelDelConfirm,
  delYesAlign,
  logoStyle,
  getOptionStyle,
  TooltipOverlayInnerStyle
};
